import { ng } from '@uirouter/angularjs/lib/angular';
import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { taOptions } from 'textangular';
import * as _ from 'underscore';
import { DefinitionsService } from '../../../../../app.common/modules/common/services/definitions.service';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { HtmlService } from '../../../../../app.common/modules/common/services/html.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { TransferFileService } from '../../../../../app.common/modules/common/services/transferFile.service';
import { WysiwygService } from '../../../../../app.common/modules/common/services/wysiwyg.service';
import { PreviousStateService } from '../../../../../app.common/modules/routes/previous-state.service';
import { AccountService } from '../../../account/account.service';
import { BrandsService } from '../../../brands/brands.service';
import { CategoriesSelectorService } from '../../../categories/categoriesSelector.service';
import { IRetailerRootScope } from '../../../core/models';
import { FoodPreferenceService } from '../../../foodPreferences/foodPreference.service';
import { IVariationAttachment } from '../../../model/open360BusinessLogicRetailersPhysicalProductsBEPhysicalProductVariation';
import { IProductVariationIngredient } from '../../../model/products/IProductVariationIngredient';
import { NfcRetailerStickersService } from '../../../nfc-stickers/nfc-retailer-stickers.service';
import { IPhysicalProductVariation, ISpecialOfferChangeMessage } from '../../models';
import { IDiscountChangeMessage, IPreparationChangeMessage, ProductBaseController } from '../../productBase.controller';
import { ProductsService } from '../../products.service';
import { OffersService } from '../../services/offers.service';

class AdvancedProductController extends ProductBaseController {
    public static $inject = [
        '$rootScope', '$scope', '$q', '$stateParams', '$timeout', '$previousState', 'productsService',
        'categoriesSelectorService', 'brandsService', 'popupService', 'appWysiwygOptions', 'htmlService',
        'definitionsService', 'wysiwygService', 'notificationService', 'accountService', '$translate', 'nfcRetailerStickersService',
        'foodPreferenceService', '$localStorage', 'offersService', '$uibModal', 'transferFileService', 'enumService'
    ];

    private dppAttachElement;
    private readonly allowedDppAttachFileSize = 200;
    private readonly allowedDppAttachExtensions = ['pdf', 'epub'];

    constructor(
        $rootScope: IRetailerRootScope,
        $scope: ng.IScope,
        $q: ng.IQService,
        $stateParams: StateParams,
        $timeout: ng.ITimeoutService,
        $previousState: PreviousStateService,
        productsService: ProductsService,
        categoriesSelectorService: CategoriesSelectorService,
        brandsService: BrandsService,
        popupService: PopupService,
        options: taOptions,
        htmlService: HtmlService,
        definitionsService: DefinitionsService,
        wysiwygService: WysiwygService,
        notificationService: NotificationService,
        accountService: AccountService,
        $translate: angular.translate.ITranslateService,
        nfcRetailerStickersService: NfcRetailerStickersService,
        foodPreferencesService: FoodPreferenceService,
        $localStorage: ngStorage.StorageService,
        offersService: OffersService,
        uibModal: ng.ui.bootstrap.IModalService,
        private transferFileService: TransferFileService,
        private enumService: EnumService
    ) {
        super($rootScope, $scope, $q, $stateParams, $timeout, $previousState, productsService,
            categoriesSelectorService, brandsService, popupService, options, htmlService, definitionsService,
            wysiwygService, notificationService, accountService, $translate, nfcRetailerStickersService, foodPreferencesService, $localStorage, offersService, uibModal);

        this.model.loadedModel = this.loadedModel;
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public $onDestroy(): void {
        if (this.dppAttachElement) {
            this.dppAttachElement.off('click');
        }
    }

    public copyVariation = async (variation: IPhysicalProductVariation) => {
        if (!this.model.isValidVariation(variation)) {
            return;
        }
        const copy = angular.copy(variation);
        this.notificationService.showWaitingMessage();
        this.waiting = true;
        copy.imagesID = [];
        copy.id = null;

        this.updateSelectedSizes(copy);
        try {
            const dictionary = await this.productsService.copyImage(variation.imagesID);
            _.forEach(variation.imagesID, (id) => {
                const newID = dictionary[id];
                if (newID) {
                    copy.imagesID.push(newID);
                }
            });
            this.notificationService.showSuccessMessage({
                title: this.$translate.instant('success'),
                body: this.$translate.instant('variation_was_copied')
            });
            this.model.edit.variations.unshift(copy);
            this.productForm.$setDirty();

        } catch (error) {
            this.notificationService.showErrorMessage(error);
        }
        this.waiting = false;
    }

    public async openIngredientsInfo() {
        try {
            await this.popupService.info({
                classPopup: 'alert--redesign modal520',
                title: this.$translate.instant('ingredient_info_dialog_title'),
                content: this.$translate.instant('ingredient_info_dialog_content')
            });
        } catch (e) { return; }
    }

    public async showIngredientAttentionIfNeed() {
        const needShowAttentions: boolean = this.model.edit.variations.length > 0 &&
            this.model.edit.variations.some((variation) => variation.ingredients.length > 0);

        if (needShowAttentions) {
            super.showIngredientAttentionDialog();
        }
    }

    public changeVariationStaffDiscount(discountMessage: IDiscountChangeMessage) {
        const foundVariation = this.model.edit.variations.find((variation) => variation.id === discountMessage.variationID);
        if (foundVariation) {
            foundVariation.discount = discountMessage.discount;
        }
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    }

    public onChangeSpecialOffer(message?: ISpecialOfferChangeMessage) {
        super.onChangeSpecialOffer(message);
    }

    public changeVariationPreparationTime(preparationMessage: IPreparationChangeMessage) {
        const foundVariation = this.model.edit.variations.find((variation) => variation.id === preparationMessage.variationID);
        if (foundVariation) {
            foundVariation.isHot = preparationMessage.isHot;
            foundVariation.preparationTime = preparationMessage.preparationTime;
        }
        if (this.productForm) {
            this.productForm.$setDirty();
        }
    }

    public onIngredientChanged(item: IProductVariationIngredient, variation: IPhysicalProductVariation) {
        this.productForm.$setDirty();
    }

    public openAttachWindow() {
        this.$timeout(() => {
            if (!this.dppAttachElement) {
                this.dppAttachElement = angular.element('#attachInput');
                this.dppAttachElement.on('change', this.addAttachment.bind(this));
            }
            this.dppAttachElement.click();
        });
    }

    public async addAttachment(element: any) {
        const files = element.target.files;
        let file: File;
        if (files && files.length > 0) {
            file = files[0];
            const fileSize = file.size / (1024 * 1024);
            const splitted = file.name.split('.');
            const fileExtension = splitted[splitted.length - 1];
            const extensionAllowed = !!this.allowedDppAttachExtensions.find((ext) => {
                return ext === fileExtension;
            });
            if (fileSize > this.allowedDppAttachFileSize) {
                this.showDppInfoDialog(
                  this.$translate.instant('file_is_too_large'),
                  this.$translate.instant('file_size_should_not_exceed', {value: this.allowedDppAttachFileSize})
                  );
            } else if (!extensionAllowed) {
                this.showDppInfoDialog(
                  this.$translate.instant('wrong_file_type'),
                  this.$translate.instant('dpp_allowed_types_message')
                );
            } else {
                try {
                    this.waiting = true;
                    this.notificationService.showWaitingMessage();
                    const id = await this.productsService.addAttachment(file);
                    this.model.edit.variations[0].attachment = {
                        ID: id,
                        FileName: file.name,
                        FileSize: file.size
                    };
                    this.setDirty();
                    this.notificationService.clearAll();
                } catch (e) {
                    this.notificationService.showErrorMessage(e);
                }
                this.waiting = false;
            }
        }
    }

    public async removeAttachment() {
        this.attachmentsForRemove.push(this.getAttach().ID);
        this.model.edit.variations[0].attachment = null;
        this.setDirty();
    }

    public getAttach(): IVariationAttachment {
        return this.model.edit.variations[0].attachment;
    }

    public async downloadAttach() {
        try {
            this.waiting = true;
            this.notificationService.showWaitingMessage();
            const attach = this.getAttach();
            const fileData = await this.productsService.getAttachment(attach.ID);
            const splittedAttachName = this.getAttach().FileName.split('.');
            const ext = splittedAttachName[splittedAttachName.length - 1];
            let type;
            if (ext === 'pdf') {
                type = this.enumService.ExportFileType.PDF;
            }
            if (ext === 'epub') {
                type = this.enumService.ExportFileType.EPUB;
            }
            this.transferFileService.transferFile(fileData, fileData.Name, type);
            this.notificationService.clearAll();
        } catch (e) {
            this.notificationService.showErrorMessage(e);
        }
        this.waiting = false;
    }

    public setDirty() {
        this.productForm.$setDirty();
    }

    public setAccessibleOutOfSession() {
        if (this.state.isNew && this.isPublisher) {
            this.model.edit.variations[0].isAccessibleOutOfSession = false;
        }
    }

    public uploadImage(imageInputId: number) {
        this.$timeout(() => {
            document.getElementById('imageInput' + imageInputId).click();
        }, 0);
    }

    private async showDppInfoDialog(title: string, message: string) {
        await this.uibModal.open({
            component: 'dppInfoDialog',
            resolve: {
                title: () => title,
                message: () => message,
            },
            windowClass: 'dpp-info-dialog'
        }).result;
    }

    private loadedModel = () => {
        if (this.state.isNew) {
            this.addVariation();
        }
        if (this.productForm) {
            this.$timeout(() => {
                this.productForm.$setPristine();
            });
        }
        $('.wrapUlTags.overflowY').slimScroll({
            height: '374px'
        });
        $('.textAreaCustScroll').slimScroll({
            height: '105px'
        });
    }
}
angular
    .module('naut').component('advancedProduct', {
        template: require('./advancedProduct.html'),
        controller: AdvancedProductController,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/advancedProduct/advancedProduct.component.ts